import '../templates/components/cart-favorites/cart-favorites.js';
import { trackABTests } from '../templates/components/tracking/trackingABTest.js';

trackABTests();
